import React from 'react';

import Heading from '@atlaskit/heading';
import { RadioGroup } from '@atlaskit/radio';

export const scopeOptions = [
  { name: 'action_scope', value: 'both', label: 'Both Jira and PagerDuty webhooks' },
  { name: 'action_scope', value: 'jira', label: 'Jira webhooks only' },
  { name: 'action_scope', value: 'pd', label: 'PagerDuty webhooks only' },
];

export const actionTypeOptions = [
  { name: 'action_type', value: 'fix', label: 'Fix missing or useless webhooks' },
  { name: 'action_type', value: 'recreate', label: 'Recreate all webhooks' },
  { name: 'action_type', value: 'delete', label: 'Delete all webhooks' },
];

const ScopeSelector = ({ isDisabled, actionType, setActionType, actionScope, setActionScope, onChange }) => {
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ width: '50%' }}>
        <Heading size="small">Action type</Heading>
        <RadioGroup
          isDisabled={isDisabled}
          value={actionType}
          options={actionTypeOptions}
          onChange={e => setActionType(e.target.value)}
        />
      </div>
      <div style={{ width: '50%' }}>
        <Heading size="small">Action scope</Heading>
        <RadioGroup
          isDisabled={isDisabled}
          value={actionScope}
          options={scopeOptions}
          onChange={e => setActionScope(e.target.value)}
        />
      </div>
    </div>
  );
};

export default ScopeSelector;
